import { render, staticRenderFns } from "./ChatRoom.vue?vue&type=template&id=16c8f259&scoped=true&"
import script from "./ChatRoom.vue?vue&type=script&lang=js&"
export * from "./ChatRoom.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoom.vue?vue&type=style&index=0&id=16c8f259&prod&scoped=true&lang=css&"
import style1 from "./ChatRoom.vue?vue&type=style&index=1&id=16c8f259&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8f259",
  null
  
)

export default component.exports